module.exports = __webpack_public_path__ + "media/images/area/area_chibaM400-d3f7d326fa85a1a9d9ca160eb428db25.jpg";